
export default function ServiceSection() {
  const features = [
    {
      icon: 'ri-search-line',
      title: '求人サイト最適化',
      description: 'Indeed・スタンバイ・求人ボックスでの露出を最大化。運送業界に特化したキーワード戦略で上位表示を実現します。',
      image: 'https://public.readdy.ai/ai/img_res/8501ab4d2bf0d2e6a3a4432261fdf7eb.jpg'
    },
    {
      icon: 'ri-edit-line',
      title: '魅力的な求人原稿作成',
      description: 'ドライバーが応募したくなる求人原稿を作成。給与・待遇・働きやすさを効果的にアピールします。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20copywriter%20creating%20compelling%20job%20descriptions%20for%20truck%20drivers%2C%20modern%20office%20workspace%20with%20computer%20showing%20job%20posting%20templates%20and%20recruitment%20content%20for%20logistics%20industry&width=600&height=400&seq=service2&orientation=landscape'
    },
    {
      icon: 'ri-line-chart-line',
      title: '応募数向上サポート',
      description: 'データ分析に基づく継続的な改善で応募数を最大化。月次レポートで効果を可視化します。',
      image: 'https://readdy.ai/api/search-image?query=Business%20analytics%20dashboard%20showing%20recruitment%20performance%20metrics%20and%20application%20increase%20charts%20for%20transportation%20company%2C%20professional%20data%20visualization%20with%20blue%20color%20scheme&width=600&height=400&seq=service3&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-6">
            <span className="text-blue-600">3つの特徴</span>で採用を成功に導きます
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            運送業界に特化した専門ノウハウで、効率的なドライバー採用を実現
          </p>
        </div>

        <div className="space-y-16 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12`}>
              <div className="lg:w-1/2">
                <img 
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-80 object-cover rounded-xl shadow-lg"
                />
              </div>
              <div className="lg:w-1/2">
                <div className="flex items-center mb-6">
                  <div className="w-12 h-12 bg-blue-600 text-white rounded-lg flex items-center justify-center mr-4">
                    <i className={`${feature.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800">{feature.title}</h3>
                </div>
                <p className="text-lg text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
